/*
 * Section radar : representation des cinq dimensions du bilan.
 * Le graphique et la liste des scores sont calcules localement.
 */

import { useMemo } from "react";
import {
  RadarChart, PolarGrid, PolarAngleAxis, Radar, ResponsiveContainer, PolarRadiusAxis,
} from "recharts";
import { ScoreExplanationDialog } from "@/components/bilan/ScoreExplanationDialog";

const SHORT_LABELS = {
  sync: "Synchronisation",
  energie: "\u00c9nergie",
  entrainement: "Activit\u00e9 physique",
  nutrition: "Nutrition",
  constance: "Constance",
};

export const RadarSection = ({ result, baremeVersion }) => {
  const radarData = useMemo(() => {
    if (!result) return [];
    return result.dimensions
      .filter((d) => d.score !== null && d.score !== undefined)
      .map((d) => ({ dimension: SHORT_LABELS[d.key] || d.label, score: d.score }));
  }, [result]);

  return (
    <section
      className="mt-8 rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-4 sm:p-6 shadow-[var(--shadow-sm)]"
      data-testid="bilan-radar-chart"
    >
      <h2 className="font-heading text-lg font-semibold text-[#060606] px-2">Tes cinq dimensions</h2>
      <div
        className="mt-2 w-full min-w-0"
        role="img"
        aria-label="Graphique radar de tes cinq dimensions. Les scores détaillés sont listés sous le graphique."
      >
        <ResponsiveContainer width="100%" height={300} minWidth={0}>
          <RadarChart data={radarData} outerRadius="72%">
            <PolarGrid stroke="rgba(35,82,119,0.18)" />
            <PolarAngleAxis dataKey="dimension" tick={{ fill: "rgba(6,6,6,0.65)", fontSize: 11, fontFamily: "Poppins" }} />
            <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
            <Radar dataKey="score" stroke="#235277" strokeWidth={2} fill="rgba(35,82,119,0.18)" dot={{ fill: "#EAFE63", stroke: "#235277", r: 3.5 }} isAnimationActive={false} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 px-2" data-testid="bilan-dimensions-list">
        {result.dimensions.map((d) => (
          <li key={d.key} className="flex items-center justify-between gap-3 text-sm">
            <span className="text-[#333333]">{d.label}</span>
            <span className="font-heading font-semibold text-[#235277] tabular-nums">
              {d.score !== null && d.score !== undefined ? `${d.score}/100` : "\u2026"}
            </span>
          </li>
        ))}
      </ul>
      <div className="mt-4 px-2">
        <ScoreExplanationDialog baremeVersion={baremeVersion} />
      </div>
    </section>
  );
};
